function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgHomeActive = function SvgHomeActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 79.45,
    y: 379.85,
    style: {
      fill: "#533222"
    },
    width: 353.1,
    height: 44.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.45,
    y: 379.85,
    style: {
      fill: "#5B3726"
    },
    width: 353.1,
    height: 17.655
  }), /*#__PURE__*/React.createElement("rect", {
    y: 88.01,
    style: {
      fill: "#744630"
    },
    width: 512,
    height: 300.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B3726"
    },
    points: "512,388.467 512,376.002 474.094,338.273 461.63,350.791 499.694,388.67 511.788,388.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B3726"
    },
    points: "0,376.373 0,388.467 0.212,388.67 12.668,388.67 50.397,350.764 37.879,338.308  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0",
    x: 35.31,
    y: 114.81,
    style: {
      fill: "#1E7C6B"
    },
    width: 441.38,
    height: 238.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B3726"
    },
    points: "0,92.195 46.724,138.911 59.207,126.429 20.789,88.011 0,88.011  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B3726"
    },
    points: "512,88.011 491.211,88.011 461.621,117.601 474.103,130.083 512,92.195  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0_1_",
    x: 35.31,
    y: 114.81,
    style: {
      fill: "#1E7C6B"
    },
    width: 441.38,
    height: 238.52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGCleanerId_0_2_",
    x: 35.31,
    y: 114.81,
    style: {
      fill: "none",
      stroke: "#1E7C6B",
      strokeMiterlimit: 10
    },
    width: 441.38,
    height: 238.52
  })), /*#__PURE__*/React.createElement("rect", {
    x: 326.62,
    y: 291.57,
    style: {
      fill: "#3B869E"
    },
    width: 114.76,
    height: 61.793
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.72,
    y: 291.57,
    style: {
      fill: "#1F6C8C"
    },
    width: 17.655,
    height: 61.793
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DBDBDB"
    },
    points: "280.505,353.359 256,335.81 297.075,275.482 321.571,293.041 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#208673"
    },
    d: "M476.69,132.096v-17.284H35.31v236.42C159.055,325.235,360.51,264.492,476.69,132.096z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-active.fe30b2ba.svg";
export { ForwardRef as ReactComponent };